<template>
    <transition name="HotspotEntrance">
        <div class="lockedHotspot" :style="[getPosition]"  v-show="ready">
            <button class="Hotspot Hotspot--lockedHotspot" :class="[getHotspotMutatorClasses]" @click="hotspotPressed">
                <div class="Hotspot__button"></div>
                <span v-html="getHotspotTitle"></span>
            </button>
            
            
            <transition name="toggleContentComponent">
                <div class="lockedHotspot__password" v-if="showLogin">
                    <input type="text" ref="loginKey" placeholder="Enter password here..." @click="focus" @keyup.enter="validate">
                    <button @click="validate">Login</button>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
export default {
    props: ['hotspot', 'hotspotCount'],
    data() {
        return {
            ready: false,
            showLogin: false,
        }
    },
    mounted() {
        this.renderHotspotCascade();
    },
    methods: {
        renderHotspotCascade() {
            let delay = 0;
            delay = (this.hotspot.index * 200) + 400;

            setTimeout(() => {
                this.ready = true;
            }, delay);
        },
        hotspotPressed() {
            this.showLogin = !this.showLogin
        },
        async validatePassword(message, keymatch) { 
            /* FLYT OVER I UTILS! */

            // encode as UTF-8 
            const msgBuffer = new TextEncoder().encode(message); // hash the message 
            const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer); // convert ArrayBuffer to Array 
            const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert bytes to hex string 
            const hashHex = hashArray.map(b => ('00' + b.toString(16)).slice(-2)).join(''); 
            return hashHex == keymatch; 
        },
        validate() {
            const input = this.$refs.loginKey.value;
            const password = this.hotspot.data.password;
            
            this.validatePassword(input, password).then((res) => { 
                if (res === true)  {
                    this.$store.commit('restrictedAccessLogin', this.hotspot.route);
                    app.api.PageManager.navigateToRoute(this.hotspot.route); 
                } else {
                    this.animatePasswordField()
                    this.focus();
                }
            });
        },
        animatePasswordField() {
            const loginKey = this.$refs.loginKey;
            // Remove the class if it's already present to allow re-triggering
            loginKey.classList.remove('shakePasswordInput');
            
            // Force a reflow to reset the animation
            void loginKey.offsetWidth;

            // Add the shake class to trigger the animation
            loginKey.classList.add('shakePasswordInput');

            // Listen for the animationend event and remove the class
            loginKey.addEventListener('animationend', () => {
                loginKey.classList.remove('shakePasswordInput');
            }, { once: true });
        }
    },
    computed: {
        getPosition() {
            return {
                left: this.hotspot.data.positionData.xPosition + 'px',
                top: this.hotspot.data.positionData.yPosition + 'px'
            }
        },
        getHotspotTitle() {
            return this.hotspot.data.alternateTitle && this.hotspot.data.alternateTitle !== '' ? this.hotspot.data.alternateTitle : this.hotspot.data.title;
        },
        getHotspotMutatorClasses() {
            return {
                'Hotspot--flipped': this.hotspot.data.flipped
            }
        },
    }
}
</script>

<style lang="scss">

.lockedHotspot {
    position: absolute;

    &__password {
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: left;
        padding: 20px;
        margin-top: 10px;
        border: var(--main-color) solid 4px;
        background: #fff;
        border-radius: 20px;
        box-shadow: var(--shadow-big);

        input[type="text"] {
            background: #fff;
            -webkit-text-security: disc;
            text-security: disc;
            margin-bottom: 15px;
            padding: 8px;
            border-bottom: solid 1px var(--main-color);
        }
        button {
            text-align: center;
            background: var(--main-color);
            color: #fff;
            width: 50%;
            padding: 5px 0;
        }
    }
}

.Hotspot--lockedHotspot {
    position: relative;

    .Hotspot__button {
        background-image: url(@/assets/img/ui/lock.svg);
        background-size: 26px!important;
        transform: rotate(0deg) !important;
        background-position: center!important;
    }
}


.shakePasswordInput {
  animation: shakePasswordInput 0.6s var(--tk-easeinout);
}

@keyframes shakePasswordInput {
  0% { transform: translateX(0); }
  15% { transform: translateX(-6px); }
  30% { transform: translateX(6px); }
  45% { transform: translateX(-4px); }
  60% { transform: translateX(4px); }
  75% { transform: translateX(-3px); }
  90% { transform: translateX(3px); }
  100% { transform: translateX(0); }
}

</style>